(function() {
  'use strict';

  // Configuration
  const CONFIG = {
    apiUrl: 'https://byune-ai.vercel.app/api/chat',
    maxChars: 500,
    minTypingTime: 800,
    maxMessages: 20,
    chatTimeout: 30000,
    cartTimeout: 10000
  };

  // State
  let messages = [];
  let products = [];
  let sessionId = sessionStorage.getItem('byune-session') || null;
  let isLoading = false;
  let isLandingMode = true;

  const PRESET_QUESTIONS = [
    { icon: '🌸', text: 'Romantisk date' },
    { icon: '💼', text: 'Jobbmöte' },
    { icon: '🌙', text: 'Mysig hemkväll' },
    { icon: '🎉', text: 'Fest & uteliv' }
  ];

  const styles = `
    .byune-chat-container {
      max-width: 700px;
      margin: 0 auto;
      padding: 20px;
      font-family: var(--font-body-family), -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
      display: flex;
      flex-direction: column;
      height: calc(100vh - 200px);
      min-height: 500px;
      background: #FAFAFA;
    }
    .byune-chat-messages {
      flex: 1;
      overflow-y: auto;
      width: 100%;
      position: relative;
      transition: opacity 0.3s ease;
    }
    .byune-chat-messages::before {
      content: '';
      position: sticky;
      top: 0;
      left: 0;
      right: 0;
      height: 20px;
      background: linear-gradient(to bottom, #FAFAFA 0%, transparent 100%);
      pointer-events: none;
      display: block;
      margin-bottom: -20px;
      z-index: 10;
    }
    .byune-chat-messages-inner {
      max-width: 750px;
      margin: 0 auto;
      padding: 20px 16px;
      display: flex;
      flex-direction: column;
      gap: 16px;
      box-sizing: border-box;
    }
    .byune-message {
      max-width: 85%;
      line-height: 1.5;
      font-size: 15px;
      animation: byune-message-in 0.3s ease-out forwards;
      opacity: 0;
    }
    @keyframes byune-message-in {
      from { opacity: 0; transform: translateY(12px); }
      to { opacity: 1; transform: translateY(0); }
    }
    .byune-message-user {
      align-self: flex-end;
      background: #121212;
      color: #FFFFFF;
      padding: 12px 16px;
      border-radius: 18px 18px 4px 18px;
    }
    .byune-message-ai {
      align-self: flex-start;
      color: #121212;
      padding: 12px 0;
    }
    .byune-message-ai p { margin: 0 0 8px 0; }
    .byune-message-ai p:last-child { margin-bottom: 0; }
    @media (max-width: 749px) {
      .byune-message { max-width: 90%; font-size: 15px; }
      .byune-message-ai { max-width: 100%; }
      .byune-message-user { padding: 10px 14px; border-radius: 16px 16px 4px 16px; }
      .byune-chat-messages-inner { padding: 16px 20px; gap: 12px; }
    }
    .byune-product-cards { display: flex; flex-wrap: wrap; gap: 16px; margin-top: 16px; }
    .byune-product-card {
      font-family: var(--font-body-family), sans-serif;
      width: 200px;
      padding-block-end: 1px;
      opacity: 0;
      transform: translateY(16px);
      animation: byune-card-in 0.4s ease forwards;
    }
    .byune-product-card:nth-child(1) { animation-delay: 0ms; }
    .byune-product-card:nth-child(2) { animation-delay: 100ms; }
    .byune-product-card:nth-child(3) { animation-delay: 200ms; }
    .byune-product-card:nth-child(4) { animation-delay: 300ms; }
    .byune-product-card:nth-child(5) { animation-delay: 400ms; }
    @keyframes byune-card-in { to { opacity: 1; transform: translateY(0); } }
    .byune-product-card__link { display: block; text-decoration: none; color: #121212; }
    .byune-product-card__media { position: relative; aspect-ratio: 1 / 1; background-color: #f8f8f8; overflow: hidden; }
    .byune-product-card__img { position: absolute; inset: 0; width: 100%; height: 100%; object-fit: cover; transition: opacity 0.3s ease; }
    .byune-product-card__img--hover { opacity: 0; }
    @media (hover: hover) and (pointer: fine) {
      .byune-product-card__media:hover .byune-product-card__img--primary { opacity: 0; }
      .byune-product-card__media:hover .byune-product-card__img--hover { opacity: 1; }
    }
    .byune-product-card__content { padding-block: 1rem; }
    .byune-product-card__title { margin: 0; font-family: var(--font-heading-family), sans-serif; font-size: 14px; font-weight: 600; text-transform: uppercase; letter-spacing: 0.05em; line-height: 1.3; color: #121212; }
    .byune-product-card__subtitle { margin: 0.35rem 0 0; font-family: var(--font-body-family), sans-serif; font-size: 12px; font-weight: 400; text-transform: uppercase; letter-spacing: 0.03em; color: #555555; }
    .byune-product-card__btn { display: flex; justify-content: center; align-items: center; gap: 0.5rem; width: 100%; height: 46px; margin-block-start: 1rem; padding-inline: 20px; background-color: #ffffff; border: 1px solid #121212; border-radius: 0; font-family: var(--font-body-family), sans-serif; font-size: 12px; font-weight: 600; text-transform: uppercase; letter-spacing: 0.78px; text-align: center; color: #121212; cursor: pointer; transition: 0.25s cubic-bezier(0.8, 0, 0.2, 1); }
    .byune-product-card__btn:hover { background-color: #121212; color: #ffffff; }
    .byune-product-card__btn:disabled { opacity: 0.5; cursor: not-allowed; }
    .byune-product-card__btn.added { background-color: #121212; color: #ffffff; }
    .byune-product-card__btn .byune-checkmark { width: 16px; height: 16px; stroke: #ffffff; stroke-width: 3; fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-dasharray: 24; stroke-dashoffset: 24; animation: byune-checkmark-draw 0.4s ease forwards; }
    @keyframes byune-checkmark-draw { to { stroke-dashoffset: 0; } }
    .byune-product-card__btn.adding { pointer-events: none; }
    .byune-product-card__btn.adding .byune-spinner { width: 16px; height: 16px; border: 2px solid transparent; border-top-color: #121212; border-radius: 50%; animation: byune-btn-spin 0.6s linear infinite; }
    @keyframes byune-btn-spin { to { transform: rotate(360deg); } }
    @media (max-width: 749px) {
      .byune-product-card { width: calc(50% - 6px); }
      .byune-product-cards { gap: 12px; }
      .byune-product-card__content { padding-block: 0.75rem; }
      .byune-product-card__title { font-size: 12px; }
      .byune-product-card__subtitle { font-size: 10px; }
      .byune-product-card__btn { height: 44px; font-size: 10px; letter-spacing: 0.5px; margin-block-start: 0.75rem; -webkit-tap-highlight-color: transparent; }
      .byune-product-card__btn:active { transform: scale(0.98); }
    }
    .byune-input-container { border-top: none; padding-top: 16px; position: relative; }
    .byune-input-wrapper { position: relative; display: flex; align-items: flex-end; }
    .byune-input { flex: 1; border: 1px solid #E5E5E5; border-radius: 16px; padding: 16px; padding-right: 60px; font-size: 16px; font-weight: 400; line-height: 24px; letter-spacing: normal; color: #141413; resize: none; height: 98px; min-height: 98px; max-height: 140px; width: 100%; font-family: inherit; outline: none; transition: border-color 0.3s ease, box-shadow 0.3s ease; background: #FFFFFF; box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08); box-sizing: border-box; -webkit-appearance: none; appearance: none; }
    .byune-input:focus { border-color: #121212; box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08), 0 0 0 3px rgba(18, 18, 18, 0.08); }
    .byune-input::placeholder { color: #999999; }
    @media (max-width: 749px) {
      .byune-input { height: 98px; min-height: 98px; max-height: 140px; padding: 16px; padding-right: 56px; border-radius: 16px; font-size: 16px; }
    }
    .byune-send-button { position: absolute; right: 12px; bottom: 12px; width: 40px; height: 40px; background: #121212; color: #FFFFFF; border: none; border-radius: 10px; cursor: pointer; transition: opacity 0.2s ease; display: flex; align-items: center; justify-content: center; padding: 0; -webkit-tap-highlight-color: transparent; }
    .byune-send-button:hover:not(:disabled) { opacity: 0.85; }
    .byune-send-button:disabled { opacity: 0.5; cursor: default; }
    .byune-send-button svg { width: 18px; height: 18px; fill: none; stroke: #FFFFFF; stroke-width: 2; stroke-linecap: round; stroke-linejoin: round; }
    .byune-char-counter { display: none; }
    .byune-char-counter.warning { color: #D90000; }

    /* Typing Indicator */
    .byune-typing-indicator { display: inline-flex; align-items: center; gap: 10px; height: 48px; }
    .byune-typing-logo { width: 40px; height: 40px; animation: byune-spin 3s linear infinite; }
    .byune-typing-text { font-family: var(--font-body-family), sans-serif; font-size: 14px; font-weight: 400; color: #555555; animation: byune-pulse 1.8s ease-in-out infinite; }
    @keyframes byune-spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
    @keyframes byune-pulse { 0%, 100% { opacity: 0.5; } 50% { opacity: 1; } }

    .byune-chat-container.landing-mode { justify-content: center; align-items: center; height: 100vh; height: 100dvh; min-height: 100vh; min-height: 100dvh; padding: 20px; padding-bottom: max(20px, env(safe-area-inset-bottom)); }
    .byune-landing-content { display: flex; flex-direction: column; align-items: center; width: 100%; max-width: 750px; padding: 0; box-sizing: border-box; transition: none; }
    @media (max-width: 749px) { .byune-chat-container.landing-mode { padding: 16px 20px; padding-bottom: max(16px, env(safe-area-inset-bottom)); } }
    .byune-landing-heading { font-family: var(--font-heading-family), sans-serif; font-size: 28px; font-weight: 600; color: #121212; margin-bottom: 16px; text-align: center; letter-spacing: 0.1em; text-transform: uppercase; }
    .byune-landing-subtext { font-family: var(--font-body-family), sans-serif; font-size: 15px; font-weight: 400; color: #555555; text-align: center; margin-bottom: 32px; max-width: 460px; line-height: 1.6; }
    @media (max-width: 749px) { .byune-landing-heading { font-size: 24px; margin-bottom: 12px; } .byune-landing-subtext { font-size: 14px; margin-bottom: 24px; padding: 0 10px; } }
    .byune-landing-input-container { width: 100%; margin-bottom: 20px; padding: 0; box-sizing: border-box; }
    @media (max-width: 749px) { .byune-landing-input-container { margin-bottom: 16px; } }
    .byune-preset-questions { display: flex; flex-wrap: nowrap; gap: 8px; justify-content: center; }
    .byune-preset-btn { display: flex; align-items: center; gap: 8px; padding: 10px 16px; background: #FFFFFF; border: 1px solid #E5E5E5; border-radius: 10px; font-family: var(--font-body-family), sans-serif; font-size: 13px; font-weight: 500; color: #121212; cursor: pointer; transition: background 0.2s ease, border-color 0.2s ease, transform 0.2s ease; white-space: nowrap; -webkit-tap-highlight-color: transparent; }
    .byune-preset-btn:hover { background: #F5F5F5; border-color: #CCCCCC; }
    .byune-preset-btn:active { background: #EEEEEE; transform: scale(0.98); }
    .byune-preset-btn .icon { font-size: 15px; }
    @media (max-width: 749px) { .byune-preset-questions { flex-wrap: wrap; gap: 8px; padding: 0; justify-content: center; } .byune-preset-btn { padding: 10px 16px; font-size: 13px; min-height: 40px; border-radius: 10px; background: #FFFFFF; border: 1px solid #E5E5E5; gap: 8px; } .byune-preset-btn .icon { font-size: 15px; } }
    .byune-chat-container { transition: all 0.4s ease; }
    .byune-scroll-bottom { position: fixed; bottom: 140px; left: 50%; transform: translateX(-50%) scale(0); width: 40px; height: 40px; background: #121212; border: none; border-radius: 50%; cursor: pointer; display: flex; align-items: center; justify-content: center; box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15); z-index: 15; transition: transform 0.2s ease, opacity 0.2s ease; opacity: 0; -webkit-tap-highlight-color: transparent; }
    .byune-scroll-bottom.visible { transform: translateX(-50%) scale(1); opacity: 1; }
    .byune-scroll-bottom:hover { transform: translateX(-50%) scale(1.05); }
    .byune-scroll-bottom svg { width: 20px; height: 20px; stroke: #FFFFFF; stroke-width: 2; fill: none; }
    @media (max-width: 749px) { .byune-scroll-bottom { bottom: 130px; width: 36px; height: 36px; } .byune-scroll-bottom svg { width: 18px; height: 18px; } }
    .byune-chat-container.chat-mode { justify-content: flex-start; align-items: stretch; height: 100vh; height: 100dvh; min-height: 100vh; min-height: 100dvh; max-width: 100%; padding: 0; position: relative; }
    .byune-chat-container.chat-mode .byune-chat-messages { display: block; opacity: 1; flex: 1; width: 100%; overflow-y: auto; -webkit-overflow-scrolling: touch; padding-bottom: 140px; }
    .byune-chat-container.chat-mode .byune-input-container { position: fixed; bottom: 0; left: 0; right: 0; max-width: 750px; margin: 0 auto; width: 100%; padding: 16px 16px; padding-bottom: max(20px, env(safe-area-inset-bottom)); box-sizing: border-box; background: #FAFAFA; z-index: 10; animation: byune-input-slide-up 0.3s ease forwards; }
    @media (max-width: 749px) { .byune-chat-container.chat-mode .byune-chat-messages { padding-bottom: 120px; } .byune-chat-container.chat-mode .byune-input-container { padding: 12px 12px; padding-bottom: max(16px, env(safe-area-inset-bottom)); } }
    .byune-chat-container.landing-mode .byune-chat-messages { display: none; opacity: 0; }
    .byune-chat-container.landing-mode .byune-input-container:not(.byune-landing-input-container) { display: none; }
    .byune-chat-container.chat-mode .byune-landing-content { display: none; }
    @keyframes byune-input-slide-up { from { opacity: 0; transform: translateY(16px); } to { opacity: 1; transform: translateY(0); } }
  `;

  function escapeHtml(text) { const div = document.createElement('div'); div.textContent = text; return div.innerHTML; }
  function addToHistory(role, content) { messages.push({ role, content }); while (messages.length > CONFIG.maxMessages) { messages.shift(); } }

  async function fetchWithTimeout(url, options, timeoutMs) {
    if (typeof AbortController === 'undefined') return fetch(url, options);
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), timeoutMs);
    try { const response = await fetch(url, { ...options, signal: controller.signal }); return response; } finally { clearTimeout(timeoutId); }
  }

  function init() {
    const container = document.getElementById('byune-chat');
    if (!container) { console.error('BYUNE Chat: Container #byune-chat not found'); return; }
    const styleEl = document.createElement('style');
    styleEl.textContent = styles;
    document.head.appendChild(styleEl);
    render(container);
  }

  function render(container) {
    container.innerHTML = '';
    const chatContainer = document.createElement('div');
    chatContainer.className = 'byune-chat-container landing-mode';
    chatContainer.id = 'byune-chat-container';

    const landingContent = document.createElement('div');
    landingContent.className = 'byune-landing-content';
    landingContent.id = 'byune-landing';

    const heading = document.createElement('h1');
    heading.className = 'byune-landing-heading';
    heading.textContent = 'HITTA DIN DOFT';
    landingContent.appendChild(heading);

    const subtext = document.createElement('p');
    subtext.className = 'byune-landing-subtext';
    subtext.innerHTML = 'Osäker på vilken parfym som passar dig? Berätta hur du vill känna dig, så matchar vi rätt doft åt dig.<br><br>Ingen tråkig quiz. Inga krångliga frågor om doftnoter. Bara du och din känsla.';
    landingContent.appendChild(subtext);

    const landingInputContainer = document.createElement('div');
    landingInputContainer.className = 'byune-input-container byune-landing-input-container';
    const landingInputWrapper = document.createElement('div');
    landingInputWrapper.className = 'byune-input-wrapper';
    const landingTextarea = document.createElement('textarea');
    landingTextarea.className = 'byune-input';
    landingTextarea.id = 'byune-landing-input';
    const isMobile = window.innerWidth < 750;
    landingTextarea.placeholder = isMobile ? 'Hur vill du känna dig?' : 'Hej! Berätta, hur vill du känna dig, eller vilken vibe jagar du? Så hittar jag din doft.';
    landingTextarea.rows = 1;
    landingTextarea.maxLength = CONFIG.maxChars;
    const landingSendBtn = document.createElement('button');
    landingSendBtn.className = 'byune-send-button';
    landingSendBtn.id = 'byune-landing-send';
    landingSendBtn.innerHTML = '<svg viewBox="0 0 24 24"><path d="M12 19V5M5 12l7-7 7 7"/></svg>';
    landingSendBtn.disabled = true;
    landingSendBtn.setAttribute('aria-label', 'Skicka');
    landingInputWrapper.appendChild(landingTextarea);
    landingInputWrapper.appendChild(landingSendBtn);
    landingInputContainer.appendChild(landingInputWrapper);
    landingContent.appendChild(landingInputContainer);

    const presetContainer = document.createElement('div');
    presetContainer.className = 'byune-preset-questions';
    PRESET_QUESTIONS.forEach(q => {
      const btn = document.createElement('button');
      btn.className = 'byune-preset-btn';
      btn.innerHTML = `<span class="icon">${q.icon}</span><span>${q.text}</span>`;
      btn.addEventListener('click', () => { handlePresetClick(q.text); });
      presetContainer.appendChild(btn);
    });
    landingContent.appendChild(presetContainer);
    chatContainer.appendChild(landingContent);

    const messagesDiv = document.createElement('div');
    messagesDiv.className = 'byune-chat-messages';
    const messagesInner = document.createElement('div');
    messagesInner.className = 'byune-chat-messages-inner';
    messagesInner.id = 'byune-messages';
    messagesDiv.appendChild(messagesInner);

    const inputContainer = document.createElement('div');
    inputContainer.className = 'byune-input-container';
    const inputWrapper = document.createElement('div');
    inputWrapper.className = 'byune-input-wrapper';
    const textarea = document.createElement('textarea');
    textarea.className = 'byune-input';
    textarea.id = 'byune-input';
    textarea.placeholder = 'Berätta hur du vill känna dig...';
    textarea.rows = 1;
    textarea.maxLength = CONFIG.maxChars;
    const sendBtn = document.createElement('button');
    sendBtn.className = 'byune-send-button';
    sendBtn.id = 'byune-send';
    sendBtn.innerHTML = '<svg viewBox="0 0 24 24"><path d="M12 19V5M5 12l7-7 7 7"/></svg>';
    sendBtn.disabled = true;
    sendBtn.setAttribute('aria-label', 'Skicka');
    inputWrapper.appendChild(textarea);
    inputWrapper.appendChild(sendBtn);
    const counter = document.createElement('div');
    counter.className = 'byune-char-counter';
    counter.id = 'byune-counter';
    counter.textContent = `0 / ${CONFIG.maxChars}`;
    inputContainer.appendChild(inputWrapper);
    inputContainer.appendChild(counter);
    chatContainer.appendChild(messagesDiv);
    chatContainer.appendChild(inputContainer);

    const scrollBtn = document.createElement('button');
    scrollBtn.className = 'byune-scroll-bottom';
    scrollBtn.id = 'byune-scroll-bottom';
    scrollBtn.innerHTML = '<svg viewBox="0 0 24 24"><path d="M12 5v14M5 12l7 7 7-7"/></svg>';
    scrollBtn.setAttribute('aria-label', 'Scrolla till botten');
    scrollBtn.addEventListener('click', () => { scrollToBottom(true); });
    chatContainer.appendChild(scrollBtn);
    messagesDiv.addEventListener('scroll', () => { updateScrollButtonVisibility(messagesDiv); });
    container.appendChild(chatContainer);

    landingTextarea.addEventListener('input', () => { landingTextarea.style.height = 'auto'; landingTextarea.style.height = Math.min(landingTextarea.scrollHeight, 140) + 'px'; const len = landingTextarea.value.length; landingSendBtn.disabled = len === 0 || len > CONFIG.maxChars || isLoading; });
    landingTextarea.addEventListener('keydown', (e) => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); const message = landingTextarea.value.trim(); if (message) switchToChatMode(message); } });
    landingSendBtn.addEventListener('click', () => { const message = landingTextarea.value.trim(); if (message) switchToChatMode(message); });
    textarea.addEventListener('input', () => { textarea.style.height = 'auto'; textarea.style.height = Math.min(textarea.scrollHeight, 140) + 'px'; const len = textarea.value.length; counter.textContent = `${len} / ${CONFIG.maxChars}`; counter.classList.toggle('warning', len > CONFIG.maxChars * 0.9); sendBtn.disabled = len === 0 || len > CONFIG.maxChars || isLoading; });
    textarea.addEventListener('keydown', (e) => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); sendMessage(); } });
    sendBtn.addEventListener('click', sendMessage);

    const backBtn = document.querySelector('.byune-chat-header__back');
    if (backBtn) { backBtn.addEventListener('click', (e) => { if (!isLandingMode) { e.preventDefault(); switchToLandingMode(); } }); }
  }

  function handlePresetClick(text) { switchToChatMode(`Jag vill ha en doft för: ${text}`); }

  function switchToChatMode(initialMessage) {
    isLandingMode = false;
    const chatContainer = document.getElementById('byune-chat-container');
    chatContainer.classList.remove('landing-mode');
    chatContainer.classList.add('chat-mode');
    const backBtn = document.querySelector('.byune-chat-header__back');
    if (backBtn) backBtn.setAttribute('aria-label', 'Tillbaka till doftmatcharen');
    const landingInput = document.getElementById('byune-landing-input');
    if (landingInput) landingInput.value = '';
    setTimeout(() => { addMessage('user', initialMessage); addToHistory('user', initialMessage); sendInitialMessage(initialMessage); }, 100);
  }

  function switchToLandingMode() {
    isLandingMode = true;
    const chatContainer = document.getElementById('byune-chat-container');
    chatContainer.classList.remove('chat-mode');
    chatContainer.classList.add('landing-mode');
    const backBtn = document.querySelector('.byune-chat-header__back');
    if (backBtn) backBtn.setAttribute('aria-label', 'Tillbaka till startsidan');
    const messagesContainer = document.getElementById('byune-messages');
    if (messagesContainer) messagesContainer.innerHTML = '';
    messages = [];
    const scrollBtn = document.getElementById('byune-scroll-bottom');
    if (scrollBtn) scrollBtn.classList.remove('visible');
    setTimeout(() => { const landingInput = document.getElementById('byune-landing-input'); if (landingInput) landingInput.focus(); }, 400);
  }

  function updateScrollButtonVisibility(container) {
    const scrollBtn = document.getElementById('byune-scroll-bottom');
    if (!scrollBtn || isLandingMode) return;
    const threshold = 100;
    const isNearBottom = container.scrollHeight - container.scrollTop - container.clientHeight < threshold;
    if (isNearBottom) scrollBtn.classList.remove('visible');
    else scrollBtn.classList.add('visible');
  }

  function scrollToBottom(smooth = false) {
    const messagesContainer = document.querySelector('.byune-chat-messages');
    if (!messagesContainer) return;
    if (smooth) messagesContainer.scrollTo({ top: messagesContainer.scrollHeight, behavior: 'smooth' });
    else messagesContainer.scrollTop = messagesContainer.scrollHeight;
    const scrollBtn = document.getElementById('byune-scroll-bottom');
    if (scrollBtn) scrollBtn.classList.remove('visible');
  }

  async function sendInitialMessage(userMessage) {
    isLoading = true;
    showTypingIndicator();
    const startTime = Date.now();
    try {
      const response = await fetchWithTimeout(CONFIG.apiUrl, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ messages, sessionId }) }, CONFIG.chatTimeout);
      if (!response.ok) throw new Error('API request failed');
      const data = await response.json();
      if (data.sessionId) { sessionId = data.sessionId; sessionStorage.setItem('byune-session', sessionId); }
      if (data.products) products = data.products;
      const productNames = extractProductNames(data.message);
      const matchedProducts = findMatchingProducts(productNames);
      const elapsed = Date.now() - startTime;
      await new Promise(resolve => setTimeout(resolve, Math.max(0, CONFIG.minTypingTime - elapsed)));
      addToHistory('assistant', data.message);
      removeTypingIndicator();
      addMessage('assistant', data.message, matchedProducts);
    } catch (error) {
      console.error('Chat error:', error);
      const elapsed = Date.now() - startTime;
      await new Promise(resolve => setTimeout(resolve, Math.max(0, CONFIG.minTypingTime - elapsed)));
      removeTypingIndicator();
      addMessage('assistant', error.name === 'AbortError' ? 'Det tog för lång tid. Försök igen.' : 'Oj, något gick fel. Försök igen om en stund.');
    } finally { isLoading = false; }
  }

  function addMessage(role, content, productMatches = []) {
    const messagesContainer = document.getElementById('byune-messages');
    if (!messagesContainer) return;
    const messageEl = document.createElement('div');
    messageEl.className = `byune-message byune-message-${role === 'user' ? 'user' : 'ai'}`;
    if (role === 'user') { messageEl.textContent = content; }
    else {
      renderAIMessage(messageEl, content);
      if (productMatches.length > 0) {
        const cardsContainer = document.createElement('div');
        cardsContainer.className = 'byune-product-cards';
        productMatches.forEach(product => { cardsContainer.appendChild(createProductCard(product)); });
        messageEl.appendChild(cardsContainer);
      }
    }
    messagesContainer.appendChild(messageEl);
    scrollToBottom();
  }

  function renderAIMessage(container, content) {
    content.split('\n').filter(p => p.trim()).forEach(paragraphText => {
      const p = document.createElement('p');
      const regex = /\*\*([^*]+)\*\*/g;
      let lastIndex = 0;
      let match;
      while ((match = regex.exec(paragraphText)) !== null) {
        if (match.index > lastIndex) p.appendChild(document.createTextNode(paragraphText.substring(lastIndex, match.index)));
        const strong = document.createElement('strong');
        strong.textContent = match[1];
        p.appendChild(strong);
        lastIndex = regex.lastIndex;
      }
      if (lastIndex < paragraphText.length) p.appendChild(document.createTextNode(paragraphText.substring(lastIndex)));
      container.appendChild(p);
    });
  }

  function extractProductNames(content) { const matches = content.match(/\*\*([^*]+)\*\*/g) || []; return [...new Set(matches.map(m => m.slice(2, -2).trim()))]; }
  function normalizeForMatching(value) { return (value ?? '').toString().toLowerCase().replace(/\s+/g, ''); }

  function findMatchingProducts(productNames) {
    const matchedProducts = []; const matchedIds = new Set();
    productNames.forEach(name => {
      const normalizedName = normalizeForMatching(name);
      if (!normalizedName) return;
      const product = products.find(p => { const t = normalizeForMatching(p && p.title); if (!t) return false; return t.includes(normalizedName) || normalizedName.includes(t); });
      if (product && !matchedIds.has(product.id)) { matchedIds.add(product.id); matchedProducts.push(product); }
    });
    return matchedProducts;
  }

  function createProductCard(product) {
    const card = document.createElement('article'); card.className = 'byune-product-card';
    const price = Math.round(parseFloat(product.price) || 0);
    const link = document.createElement('a'); link.className = 'byune-product-card__link'; link.href = product.url || `/products/${product.handle || ''}`;
    const media = document.createElement('div'); media.className = 'byune-product-card__media';
    if (product.image) {
      const img = document.createElement('img'); img.className = 'byune-product-card__img byune-product-card__img--primary'; img.src = product.image; img.alt = product.title; img.loading = 'lazy'; media.appendChild(img);
      if (product.imageHover) { const imgHover = document.createElement('img'); imgHover.className = 'byune-product-card__img byune-product-card__img--hover'; imgHover.src = product.imageHover; imgHover.alt = product.title; imgHover.loading = 'lazy'; media.appendChild(imgHover); }
    }
    link.appendChild(media);
    const content = document.createElement('div'); content.className = 'byune-product-card__content';
    const title = document.createElement('h3'); title.className = 'byune-product-card__title'; title.textContent = product.title; content.appendChild(title);
    const subtitle = document.createElement('p'); subtitle.className = 'byune-product-card__subtitle'; subtitle.textContent = '30ML EAU DE PARFUM'; content.appendChild(subtitle);
    link.appendChild(content); card.appendChild(link);
    const button = document.createElement('button'); button.type = 'button'; button.className = 'byune-product-card__btn'; button.dataset.variantId = product.variantId;
    if (product.available) {
      const btnText = document.createElement('span'); btnText.textContent = 'LÄGG TILL';
      const separator = document.createElement('span'); separator.className = 'byune-product-card__separator'; separator.textContent = ' · ';
      const priceSpan = document.createElement('span'); priceSpan.className = 'byune-product-card__price--current'; priceSpan.textContent = `${price} KR`;
      button.appendChild(btnText); button.appendChild(separator); button.appendChild(priceSpan);
      button.addEventListener('click', (e) => { e.preventDefault(); addToCart(product.variantId, button, price); });
    } else { button.textContent = 'SLUTSÅLD'; button.disabled = true; }
    card.appendChild(button);
    return card;
  }

  async function addToCart(variantId, button, price) {
    if (!variantId) return;
    const numericId = variantId.split('/').pop();
    const originalContent = button.innerHTML;
    button.disabled = true; button.classList.add('adding'); button.innerHTML = '<span class="byune-spinner"></span>';
    try {
      const response = await fetchWithTimeout('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: numericId, quantity: 1 }) }, CONFIG.cartTimeout);
      if (response.ok) {
        button.classList.remove('adding'); button.classList.add('added'); button.innerHTML = '<svg class="byune-checkmark" viewBox="0 0 24 24"><path d="M5 12l5 5L20 7"/></svg><span>TILLAGD!</span>';
        updateCartCount(); document.dispatchEvent(new CustomEvent('cart:updated'));
        setTimeout(() => { button.innerHTML = originalContent; button.classList.remove('added'); button.disabled = false; }, 2500);
      } else throw new Error('Failed to add to cart');
    } catch (error) {
      console.error('Add to cart error:', error); button.classList.remove('adding'); button.innerHTML = '<span>FEL - FÖRSÖK IGEN</span>';
      setTimeout(() => { button.innerHTML = originalContent; button.disabled = false; }, 2000);
    }
  }

  function updateCartCount() {
    fetch('/cart.js').then(res => res.json()).then(cart => {
      const chatCartCount = document.getElementById('chat-cart-count');
      if (chatCartCount) chatCartCount.textContent = cart.item_count > 0 ? cart.item_count : '';
      ['.cart-count','.cart-item-count','[data-cart-count]','.js-cart-count','.byune-header__cart-count'].forEach(s => { const el = document.querySelector(s); if (el) el.textContent = cart.item_count; });
    }).catch(() => {});
  }

  function showTypingIndicator() {
    const messagesContainer = document.getElementById('byune-messages');
    if (!messagesContainer) return;
    const indicator = document.createElement('div');
    indicator.className = 'byune-message byune-message-ai';
    indicator.id = 'byune-typing';
    const typingDiv = document.createElement('div');
    typingDiv.className = 'byune-typing-indicator';
    const logo = document.createElement('img');
    logo.className = 'byune-typing-logo';
    logo.src = 'https://cdn.shopify.com/s/files/1/0976/1505/3130/files/logo_outside.svg?v=1763675680';
    logo.alt = 'BYUNE tänker...';
    logo.onerror = () => { typingDiv.textContent = '...'; typingDiv.style.fontSize = '24px'; typingDiv.style.fontWeight = 'bold'; };
    typingDiv.appendChild(logo);
    const typingText = document.createElement('span');
    typingText.className = 'byune-typing-text';
    typingText.textContent = 'Hittar din doft...';
    typingDiv.appendChild(typingText);
    indicator.appendChild(typingDiv);
    messagesContainer.appendChild(indicator);
    scrollToBottom();
  }

  function removeTypingIndicator() { const indicator = document.getElementById('byune-typing'); if (indicator) indicator.remove(); }

  async function sendMessage() {
    const input = document.getElementById('byune-input');
    const sendBtn = document.getElementById('byune-send');
    const userMessage = input.value.trim();
    if (!userMessage || userMessage.length > CONFIG.maxChars || isLoading) return;
    input.value = ''; input.style.height = 'auto'; document.getElementById('byune-counter').textContent = `0 / ${CONFIG.maxChars}`; sendBtn.disabled = true;
    addMessage('user', userMessage); addToHistory('user', userMessage);
    isLoading = true; showTypingIndicator();
    const startTime = Date.now();
    try {
      const response = await fetchWithTimeout(CONFIG.apiUrl, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ messages, sessionId }) }, CONFIG.chatTimeout);
      if (!response.ok) throw new Error('API request failed');
      const data = await response.json();
      if (data.sessionId) { sessionId = data.sessionId; sessionStorage.setItem('byune-session', sessionId); }
      if (data.products) products = data.products;
      const productNames = extractProductNames(data.message);
      const matchedProducts = findMatchingProducts(productNames);
      const elapsed = Date.now() - startTime;
      await new Promise(resolve => setTimeout(resolve, Math.max(0, CONFIG.minTypingTime - elapsed)));
      addToHistory('assistant', data.message); removeTypingIndicator(); addMessage('assistant', data.message, matchedProducts);
    } catch (error) {
      console.error('Chat error:', error);
      const elapsed = Date.now() - startTime;
      await new Promise(resolve => setTimeout(resolve, Math.max(0, CONFIG.minTypingTime - elapsed)));
      removeTypingIndicator();
      addMessage('assistant', error.name === 'AbortError' ? 'Det tog för lång tid. Försök igen.' : 'Oj, något gick fel. Försök igen om en stund.');
    } finally { isLoading = false; }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();